import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { I18nService } from '../../../../../shared/src/lib/shared/services/local/i18n.service';
import { __ } from 'projects/shared/src/lib/shared/functions/object.functions';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {

  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private injector: Injector
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ INTERFACES
  // -----------------------------------------------------------------------------------------------------

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const i18nService = this.injector.get(I18nService);

    if (!__.IsNullOrUndefinedOrEmpty(i18nService) && !__.IsNullOrUndefinedOrEmpty(i18nService.language)) {
      request = request.clone({
        setHeaders: { 'Accept-Language' : i18nService.language }
      });  
    }
   
    return next.handle(request);
  }
}
